import { VoicePersonaProvider } from '../voicePersona.js';

export enum AssistantDefinitionState {
  Published = 'Published',
}

export enum AssistantFirstMessageMode {
  AssistantSpeaksFirst = 'AssistantSpeaksFirst',
  AssistantSpeaksFirstWithModelGeneratedMessage = 'AssistantSpeaksFirstWithModelGeneratedMessage',
  AssistantWaitsForUser = 'AssistantWaitsForUser',
}

export enum AssistantOptionMode {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}

export enum VoiceCallBackgroundSound {
  Off = 'Off',
  Office = 'Office',
}

export enum VoiceCallIdleMessage {
  AreYouStillThere = 'AreYouStillThere',
  IsThereAnythingElseYouNeedHelpWith = 'IsThereAnythingElseYouNeedHelpWith',
  FeelFreeToAskMeAnyQuestions = 'FeelFreeToAskMeAnyQuestions',
  HowCanIAssistYouFurther = 'HowCanIAssistYouFurther',
  LetMeKnowIfThereIsAnythingYouNeed = 'LetMeKnowIfThereIsAnythingYouNeed',
  ImStillHereIfYouNeedAssistance = 'ImStillHereIfYouNeedAssistance',
  ImReadyToHelpWheneverYouAre = 'ImReadyToHelpWheneverYouAre',
  IsThereSomethingSpecificYouAreLookingFor = 'IsThereSomethingSpecificYouAreLookingFor',
  ImHereToHelpWithAnyQuestionsYouHave = 'ImHereToHelpWithAnyQuestionsYouHave',
}

export enum VoiceCallLanguage {
  Bulgarian = 'bg',
  Chinese = 'zh',
  Czech = 'cs',
  Danish = 'da',
  Dutch = 'nl',
  English = 'en',
  Finnish = 'fi',
  French = 'fr',
  German = 'de',
  Hindi = 'hi',
  Hungarian = 'hu',
  Indonesian = 'id',
  Italian = 'it',
  Japanese = 'ja',
  Korean = 'ko',
  Malay = 'ms',
  Multilingual = 'multi',
  Polish = 'pl',
  Portuguese = 'pt',
  Romanian = 'ro',
  Russian = 'ru',
  Slovak = 'sk',
  Spanish = 'es',
  Swedish = 'sv',
  Tamil = 'ta',
  Turkish = 'tr',
  Ukrainian = 'uk',
  Vietnamese = 'vi',
}

export const ASSISTANT_VOICE_SPEED_RANGE_BY_VOICE_PROVIDER: Partial<
  Record<VoicePersonaProvider, { min: number; max: number; displayName: string }>
> = {
  [VoicePersonaProvider.Cartesia]: {
    // https://docs.vapi.ai/voice-fallback-plan#cartesia
    min: 0.6,
    max: 1.5,
    displayName: 'Cartesia',
  },
  [VoicePersonaProvider.ElevenLabs]: {
    // https://docs.vapi.ai/voice-fallback-plan#elevenlabs
    min: 0.7,
    max: 1.2,
    displayName: 'ElevenLabs',
  },
};
